import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import axios from "axios";
import VueAxios from "vue-axios";

const formularios = {
  state: {},
  getters: {},
  actions: {
    sendFormulario: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/save", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendTrabajaConNosotros: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/curriculumn/save", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendPromoTortugas: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/turtles/save", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendPromoPatrullaCanina: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/turtles/save", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendNewsletter: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/19", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendNewsletterCOD: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/28", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendNewsletterWWE: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/26", data)
          .then((result) => {
            result.data.status ? resolve(true) : reject(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendNewsletterGeneric: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/contact/" + data.id, data)
          .then((result) => {
            result.data.status ? resolve(true) : resolve(false);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendCodeOverwatch: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/prizes/check", data)
          .then((result) => {
            resolve(result.data.status);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendInfoOverwatch: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios
          .post("api/prizes/save", data)
          .then((result) => {
            resolve(result.data.prize.code);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {},
};

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js